let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("jeVRv")).then(() => parcelRequire('03Obs'));